import { Injectable, inject } from '@angular/core';

import { HttpService } from '@asset-solutions/shared/http';
import type { Observable } from 'rxjs';

import type { Order, TrackingRequest } from './order.interface';

@Injectable({
  providedIn: 'root'
})
export class OrderTrackingService {
  private apiPath = '/orders/tracking';
  private httpService = inject(HttpService);

  public getOrderTrackingInfo({ orderId, legStopId, token }: TrackingRequest): Observable<Order> {
    if (orderId.length > 10) {
      return this.httpService.post({
        api: `${this.apiPath}/${orderId}`,
        body: { token },
        searchParameters: { legStopId }
      });
    } else {
      return this.httpService.post({
        api: `${this.apiPath}`,
        searchParameters: { tmsId: orderId, legStopId },
        body: { token }
      });
    }
  }
}
